import React from 'react';

export const ErrorIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="2 2 24 24" {...props}>
    <path
      stroke="#F64D43"
      fill="none"
      d="M14 22.815A8.806 8.806 0 0 1 5.187 14 8.804 8.804 0 0 1 14 5.187a8.807 8.807 0 0 1 8.815 8.814A8.807 8.807 0 0 1 14 22.816zm0 0A8.807 8.807 0 0 0 22.815 14 8.806 8.806 0 0 0 14 5.186 8.806 8.806 0 0 0 5.187 14a8.807 8.807 0 0 0 8.814 8.815zm0-14v7.259m0 2.074v1.038"
    />
  </svg>
);
